module.exports = __webpack_public_path__ + "static/img/she3.309cc7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/she3.png
// module id = wYNe
// module chunks = 5